module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_6005.04ace751.png";